import React from 'react'

import './article-float-menu.scss'
import ArticleAutopauta from '../../../shared/components/atoms/article-autopauta/article-autopauta';

const ArticleFloatMenu = props => {
    const { infoArticle, slugPrefix } = props;

    return (
        <aside className="f-autopauta-container">
            <div className={"f-top-autopauta " + ((typeof infoArticle.autopauta[1] !== 'undefined') ? 'with-bottom ' : '')}>
                <ArticleAutopauta
                    infoAutopauta={infoArticle.autopauta[0]}
                    slugPrefix={slugPrefix}
                />
            </div>

            {(typeof infoArticle.autopauta[1] !== 'undefined') &&
                <div className={"f-bottom-autopauta " + (infoArticle.autopauta[1].tipoDeAutopauta === 'Artículos Relacionados' ? 'no-flex ' : '')}>
                    <ArticleAutopauta
                        infoAutopauta={infoArticle.autopauta[1]}
                        slugPrefix={slugPrefix}
                    />
                </div>
            }
        </aside>
    )
}

export default ArticleFloatMenu
